<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-form @submit.prevent="submit()">
          <v-card-title class="headline gradiente lighten-2 elevation-3">
            <span class="white--text">{{ title }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        :error-messages="nameErrors"
                        v-model="$v.conceptForm.name.$model"
                        label="Concepto"
                        required
                      />
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :error-messages="amountErrors"
                        v-model="$v.conceptForm.amount.$model"
                        label="Monto"
                        required
                        :disabled="!flags.editable"
                        @keypress="isNumber($event)"
                        @keyup="validationDecimals($event)"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :error-messages="penaltyErrors"
                        v-model="$v.conceptForm.penalty.$model"
                        label="Recargos"
                        required
                        :disabled="!flags.editable"
                        @keypress="isNumber($event)"
                        @keyup="validationDecimals($event)"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        v-model="$v.conceptForm.frequency.$model"
                        item-text="label"
                        item-value="value"
                        :items="frequencies"
                        label="Frecuencia"
                        outline
                        required
                        :error-messages="frequencyErrors"
                        :disabled="!flags.editable"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn :disabled="working.wUpdate" flat @click="cancel">Cancelar</v-btn>
            <v-btn :disabled="working.wUpdate" color="primary darken-1" type="submit" flat>Guardar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <loading v-model="working.wUpdate" text="Trabajando..."/>
    <success v-model="toast.success" text="Creación Exitosa"/>
    <error v-model="toast.failed" :text="toast.eMessage"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import { funciones } from "../../Mixins/Funciones.js";
import loading from "../Dialogs/Loading.vue";
import success from "../Dialogs/Success.vue";
import error from "../Dialogs/Error.vue";
import { setTimeout } from "timers";
import {TheMask} from 'vue-the-mask'

export default {
  props: ["title", "concept", "value", "roles"],
  components: {
    loading,
    success,
    error,
  },
  validations: {
    conceptForm: {
      name: { required },
      amount: { required },
      penalty: { required },
      frequency: { required },
    },
  },
  watch: {
    value() {
      if (this.value) {
        if (this.concept === null) {
          this.flags.editable = true;
        } else {
          this.conceptForm.id = this.concept.id;
          this.conceptForm.name = this.concept.name;
          this.conceptForm.amount = this.concept.amount;
          this.conceptForm.penalty = this.concept.penalty;
          this.conceptForm.frequency = this.concept.frequency;

          this.flags.editable = this.concept.editable;
        }
      } else {
        this.flags.editable = false;
      }
    },
  },
  mounted() {},
  data: () => ({
    conceptForm: {
      name: "",
      amount: "",
      penalty: "",
      frequency: "",
    },
    working: {
      wUpdate: false,
    },
    toast: {
      success: false,
      failed: false,
      eMessage: "",
    },
    flags: {
      changed: false,
      editable: false,
    },
    frequencies: [
      {
        value: "WEEKLY",
        label: "Semanal",
      },
      {
        value: "BIWEEKLY",
        label: "Catorcenal",
      },
      {
        value: "MONTHLY",
        label: "Mensual",
      },
    ],
  }),
  methods: {
    submit(event = null) {
      this.$v.conceptForm.$touch();
      if (!this.$v.conceptForm.$invalid) {
        this.working.wUpdate = true;
        if (this.concept == null) {
          this.$store
            .dispatch("paymentConcepts/createConcept", this.conceptForm)
            .then((response) => {
              this.working.wUpdate = false;
              this.toast.success = true;
              this.$v.conceptForm.$reset();
              this.$emit("created", response.data);
              this.close();
            })
            .catch((error) => {
              this.working.wUpdate = false;
              this.toast.failed = true;
              this.toast.eMessage = "No fue posible crear el concepto de pago";
            });
        } else {
          this.$store
            .dispatch("paymentConcepts/updateConcept", {
              id: this.concept.id,
              request: this.conceptForm,
            })
            .then((response) => {
              this.working.wUpdate = false;
              this.toast.success = true;
              this.$v.conceptForm.$reset();
              this.$emit("updated", response.data);
              this.close();
            })
            .catch((error) => {
              this.working.wUpdate = false;
              this.toast.failed = true;
              this.toast.eMessage = "No fue posible actualizar el concepto de pago";
            });
        }
      }
    },
    cancel() {
      this.$emit("cancelled");
      this.close();
    },
    close() {
      this.$v.conceptForm.$reset();
      this.conceptForm = {
        name: "",
        amount: "",
        penalty: "",
        frequency: "",
      };
      this.flags.changed = false;
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      var currentValue = evt.target.value;
      var arrayDeCadenas = currentValue.split(".");
      if(arrayDeCadenas[1] !== undefined && arrayDeCadenas[1].length === 2){
        evt.preventDefault();
      }
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        if( arrayDeCadenas !== undefined && arrayDeCadenas.length === 2 && charCode === 46) {
          evt.preventDefault();
        }
        return true;
      }
    },
    validationDecimals: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if(charCode !== 8){
        var currentValue = evt.target.value;
          var arrayDeCadenas = currentValue.split(".");
          if(arrayDeCadenas[0].length === 5 && arrayDeCadenas[1] === undefined) {
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
              evt.preventDefault();
            } else {
              evt.target.value = currentValue + ".";
            }
          }
      }
    },
    handleKeyDown(e) { //method to handle the keypress
      if (e.code === "Escape") {
        this.cancel();
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown); //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown); //will detach the event listener once the component is destroyed
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.conceptForm.name.$dirty) return errors;
      !this.$v.conceptForm.name.required && errors.push("Nombre obligatorio");
      return errors;
    },
    amountErrors() {
      const errors = [];
      if (!this.$v.conceptForm.amount.$dirty) return errors;
      !this.$v.conceptForm.amount.required && errors.push("Monto obligatorio");

      return errors;
    },
    penaltyErrors() {
      const errors = [];
      if (!this.$v.conceptForm.penalty.$dirty) return errors;
      !this.$v.conceptForm.penalty.required &&
        errors.push("Recargos obligatorio");

      return errors;
    },
    frequencyErrors() {
      const errors = [];
      if (!this.$v.conceptForm.frequency.$dirty) return errors;
      !this.$v.conceptForm.frequency.required &&
        errors.push("Frecuencia de recargo obligatoria");
      return errors;
    },
  },
};
</script>

<style>
</style>
